module.exports = __webpack_public_path__ + "static/media/Close.04704fb2.svg";